import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { Tag } from "primereact/tag";

import { Checkbox, ConfirmDialog, Dialog, DialogFooter, DialogHeader, FormField } from "@/ds";
import {
  ADICIONAR_LABEL,
  NOME_LABEL,
  NOME_PLACEHOLDER,
  NOVO_GRUPO_TITULO,
  SUBGRUPOS_LABEL,
  TIPOS_AJUDA,
  TIPOS_LABEL,
} from "./novo-grupo-dialog.constants";
import styles from "./novo-grupo-dialog.module.scss";
import type { NovoGrupoDialogViewModel } from "./types-novo-grupo-dialog";

const RODAPE_DIALOGO = { footer: { className: styles.dialogoRodape } };

export function NovoGrupoDialogView({
  formId,
  tipos,
  nome,
  subgrupos,
  isSubmitting,
  submitError,
  enviar,
  cancelar,
  descarte,
}: NovoGrupoDialogViewModel) {
  return (
    <>
      <Dialog
        visible
        size="md"
        className={styles.dialogo}
        contentClassName={styles.corpo}
        onHide={cancelar}
        locked={isSubmitting}
        focusOnShow={false}
        header={<DialogHeader title={NOVO_GRUPO_TITULO} />}
        pt={RODAPE_DIALOGO}
        footer={
          <DialogFooter
            className={styles.rodape}
            confirmLabel={ADICIONAR_LABEL}
            formId={formId}
            loading={isSubmitting}
            locked={isSubmitting}
            onCancel={cancelar}
            testId="novo-grupo"
          />
        }
        data-testid="novo-grupo-dialog"
      >
        <form id={formId} className={styles.form} onSubmit={enviar} noValidate>
          <fieldset className={styles.tipos} data-testid="novo-grupo-tipos">
            <legend className={styles.legenda}>{TIPOS_LABEL}</legend>
            {tipos.opcoes.map((tipo) => (
              <label key={tipo.id} className={styles.tipo}>
                <Checkbox
                  checked={tipo.marcado}
                  disabled={tipo.desabilitado || isSubmitting}
                  onChange={tipo.alternar}
                />
                {tipo.rotulo}
              </label>
            ))}
            <p className={styles.ajuda}>{TIPOS_AJUDA}</p>
            {tipos.erro ? <small className={styles.erro}>{tipos.erro}</small> : null}
          </fieldset>

          <FormField.Root required error={nome.erro}>
            <FormField.Label>{NOME_LABEL}</FormField.Label>
            <FormField.Control>
              <InputText
                value={nome.valor}
                maxLength={nome.max}
                placeholder={NOME_PLACEHOLDER}
                onChange={(evento) => nome.digitar(evento.target.value)}
                disabled={isSubmitting}
                data-testid="novo-grupo-nome"
              />
            </FormField.Control>
            <FormField.Error />
            <small className={styles.contador} data-testid="novo-grupo-contador">
              {`${nome.valor.length}/${nome.max}`}
            </small>
          </FormField.Root>

          <div className={styles.subgrupos} data-testid="novo-grupo-subgrupos">
            <p className={styles.legenda}>{SUBGRUPOS_LABEL}</p>
            {subgrupos.previa.length > 0 ? (
              <div className={styles.tags} data-testid="novo-grupo-previa">
                {subgrupos.previa.map((subgrupo) => (
                  <Tag key={subgrupo} value={subgrupo} severity="secondary" />
                ))}
              </div>
            ) : null}
            <p className={styles.ajuda}>{subgrupos.ajuda}</p>
          </div>

          {submitError ? (
            <Message
              className="p-message-block"
              severity="error"
              text={submitError}
              data-testid="novo-grupo-submit-error"
            />
          ) : null}
        </form>
      </Dialog>
      {descarte ? <ConfirmDialog {...descarte} /> : null}
    </>
  );
}
